import React from 'react';
import { Calendar } from 'react-calendar';
import { instanceOf, func, string } from 'prop-types';
import dayjs from 'dayjs';

import { PrevIcon } from '@atoms';
import { dayjs as dayjsUtil } from '@utils';
import { theme } from '@styles';

import { ReactComponent as Dropdown } from '@assets/svgs/Dropdown.svg';
import { CalendarContainer, NextIcon } from './styles';

const DatePicker = ({ selectedDate, onDateSelect, type, minDate, maxDate, tileDisabled }) => (
  <CalendarContainer type={type}>
    <Calendar
      {...(!selectedDate && minDate && { defaultActiveStartDate: minDate })}
      calendarType="hebrew"
      showNeighboringMonth={false}
      formatMonthYear={(locale, calendarDate) => dayjs(calendarDate).format('MMM YYYY')}
      formatMonth={(locale, calendarDate) => dayjs(calendarDate).format('MMM')}
      value={selectedDate}
      onClickDay={onDateSelect}
      onClickMonth={onDateSelect}
      {...(tileDisabled && { tileDisabled })}
      prevLabel={<PrevIcon SVG={Dropdown} color={theme.color.black} height="12px" />}
      nextLabel={<NextIcon SVG={Dropdown} color={theme.color.black} height="12px" />}
      {...(type === 'month' && { minDate })}
      {...(maxDate && { maxDate })}
      minDetail={type}
      maxDetail={type}
      defaultView={type}
      locale="en"
    />
  </CalendarContainer>
);

DatePicker.defaultProps = {
  minDate: dayjsUtil().$d,
  maxDate: null,
  selectedDate: dayjsUtil().$d,
  tileDisabled: null,
};

DatePicker.propTypes = {
  maxDate: instanceOf(Date),
  minDate: instanceOf(Date),
  selectedDate: instanceOf(Date),
  onDateSelect: func.isRequired,
  type: string.isRequired,
  tileDisabled: func,
};

export default DatePicker;
